<script>
    import { projectSettings, acceptedFileUploadList } from "../../config";
    import { isValid } from "../../validation";
    import model from "../../stores/modelStore";
    import lookups from "../../stores/lookupStore";

    import FormRow from "../../components/FormRow.svelte";
    import FormColumn from "../../components/FormColumn.svelte";
    import RadioGroup from "../../components/RadioGroup.svelte";
    import TextInput from "../../components/TextInput.svelte";
    import DropZone from "../../components/DropZone.svelte";
    import YesNoGroup from "../../components/YesNoGroup.svelte";
    import NavigationButtons from "../../components/NavigationButtons.svelte";
    import PageSection from "../../components/PageSection.svelte";
    import Form from "../../components/Form.svelte";

    // props
    export let pageTitle = null;
    export let disabled = false;
    export let persistUrl = false;
    export let lastVisitedPage = null;

    const dropZoneOptions = {
        url: "/api/file-upload?token=" + $model.token,
        acceptedFiles: acceptedFileUploadList,
        fileUploadToken: $model.token,
    };
    $model.documentList = $model.documentList || [];

    let buttons = null;

    // component state updating
    if (!disabled) {
        $model.lastPageVisited = lastVisitedPage;
        document.title = pageTitle;
    }

    const handleSubmit = async (e) => {
        buttons.blockNext();

        let errors = isValid();

        if (!errors.length) {
            let response = await model.saveModelAsync(persistUrl);

            if (!response.success) {
                console.log(displayError);
            } else {
                buttons.next();
            }
        } else {
            errors[0].scrollIntoView({ behavior: "smooth" });
        }

        buttons.unblock();
    };
</script>

<PageSection>
    <Form {disabled} id="form-agreements" on:submit={handleSubmit}>
        <FormRow class="justify-content-center confirmation-hide">
            <FormColumn>
                <h4 class="text-center">
                    {@html projectSettings.classActionName}
                </h4>
                <h1 class="text-center">Additional Information</h1>
            </FormColumn>
        </FormRow>

        <p>
            Toyota has stated that it sent all registered owners letters on the DPF issue, in November 2018 and in July 2021 onwards.
        </p>

        <FormRow>
            <FormColumn>
                <YesNoGroup
                    required
                    {disabled}
                    name="receivedFirstLetter"
                    label="Do you recall receiving the first letter (sent November 2018)?"
                    bind:value={$model.receivedFirstLetter}
                />
            </FormColumn>
        </FormRow>

        {#if $model.receivedFirstLetter == "Yes"}
            <p>Please upload a copy below or forward to us.</p>
        {/if}

        <FormRow>
            <FormColumn>
                <YesNoGroup
                    required
                    {disabled}
                    name="receivedSecondLetter"
                    label="Do you recall receiving the second letter (sent July 2021 onwards)?"
                    bind:value={$model.receivedSecondLetter}
                />
            </FormColumn>
        </FormRow>

        {#if $model.receivedSecondLetter == "Yes"}
            <p>Please upload a copy below or forward to us.</p>
        {/if}

        <FormRow>
            <FormColumn>
                <YesNoGroup
                    required
                    {disabled}
                    name="dpfSoftwareProblem"
                    label="Have you noticed any problems to your vehicle arising from the DPF software?"
                    bind:value={$model.dpfSoftwareProblem}
                />
            </FormColumn>
        </FormRow>

        {#if $model.dpfSoftwareProblem == "Yes"}
            <FormRow>
                <FormColumn>
                    <TextInput
                        required
                        {disabled}
                        maxlength="1000"
                        name="dpfProblemWhen"
                        label="When did you notice the issue?"
                        bind:value={$model.dpfProblemWhen}
                    />
                </FormColumn>
            </FormRow>
        {/if}

        <FormRow>
            <FormColumn>
                <RadioGroup
                    required
                    {disabled}
                    name="dpfRequestFix"
                    label="Did you request the DPF be fixed or was it provided as part of a regular vehicle service?"
                    bind:value={$model.dpfRequestFix}
                    optionList={$lookups.dpfRequestFixTypes}
                    labelProperty="lookupName"
                    valueProperty="id"
                    cols="12"
                />
            </FormColumn>
        </FormRow>

        {#if $model.dpfRequestFix == "64"}
            <FormRow>
                <FormColumn>
                    <RadioGroup
                        required
                        {disabled}
                        name="dpfRequestFixWhy"
                        label="Why did you request the DPF be fixed?"
                        bind:value={$model.dpfRequestFixWhy}
                        optionList={$lookups.dpfRequestFixWhyTypes}
                        labelProperty="lookupName"
                        valueProperty="id"
                        cols="12"
                    />
                </FormColumn>
            </FormRow>
        {/if}

        <FormRow>
            <FormColumn>
                <YesNoGroup
                    required
                    {disabled}
                    name="dpfSoftwareUpgrade"
                    label="Did you have the DPF software upgraded and/or the DPF replaced on your vehicle?"
                    bind:value={$model.dpfSoftwareUpgrade}
                />
            </FormColumn>
        </FormRow>

        {#if $model.dpfSoftwareUpgrade == "Yes"}
            <FormRow>
                <FormColumn>
                    <TextInput
                        required
                        {disabled}
                        maxlength="1000"
                        name="dpfSoftwareReplacedWho"
                        label="Who completed the upgrade/replacement?"
                        bind:value={$model.dpfSoftwareReplacedWho}
                    />
                </FormColumn>
            </FormRow>

            <FormRow>
                <FormColumn>
                    <TextInput
                        required
                        {disabled}
                        maxlength="1000"
                        name="dpfSoftwareReplacedWhen"
                        label="When was the upgrade/replacement completed?"
                        bind:value={$model.dpfSoftwareReplacedWhen}
                    />
                </FormColumn>
            </FormRow>
        {/if}

        <FormRow>
            <FormColumn>
                <h3>File upload</h3>
                <p>Please upload, or forward to us, copies of;</p>
                <ul class="mb-3">
                    <li>
                        The letters sent from Toyota regarding the DPF issue in
                        November 2018 and July 2021
                    </li>
                    <li>Your service records</li>
                </ul>
                <DropZone
                    options={dropZoneOptions}
                    id={disabled}
                    message="<b>Upload files for your registration</b><br>Drag files here or click to upload"
                    bind:documentList={$model.documentList}
                ></DropZone>
            </FormColumn>
        </FormRow>

        <FormRow class="confirmation-hide">
            <FormColumn>
                <NavigationButtons bind:buttons />
            </FormColumn>
        </FormRow>
    </Form>
</PageSection>
